import type { ComboboxValueChangeReasonType } from '../types/combobox-root.types';

/**
 * Updates the set of selected values based on the operation type
 *
 * @param newValue - The value to operate on
 * @param selectedValues - Current selected values
 * @param operation - The type of change operation (add/remove/toggle/replace/clear)
 * @returns A new Set containing the updated selected values
 */
export const updateSelectedValues = (
  newValue: string,
  selectedValues: Set<string>,
  operation: ComboboxValueChangeReasonType,
): Set<string> => {
  const newSelectedValues = new Set(selectedValues);

  switch (operation) {
    case 'add': {
      newSelectedValues.add(newValue);
      break;
    }
    case 'remove': {
      newSelectedValues.delete(newValue);
      break;
    }
    case 'toggle': {
      if (newSelectedValues.has(newValue)) {
        newSelectedValues.delete(newValue);
      } else {
        newSelectedValues.add(newValue);
      }
      break;
    }
    case 'replace': {
      newSelectedValues.clear();
      newSelectedValues.add(newValue);
      break;
    }
    case 'clear': {
      newSelectedValues.clear();
      break;
    }
  }

  return newSelectedValues;
};
